import React from "react";
import SaveIcon from "@mui/icons-material/Save";
import CustomBtn from "./ButtonTemplate";

interface SaveBtnProps {
  action: () => void;
  tip?: string;
}

function SaveBtn({ action, tip }: SaveBtnProps) {
  return (
    <CustomBtn action={action} type="success" icon={<SaveIcon />} tip={tip} />
  );
}

export default SaveBtn;
